<!--
 * @Description: 我的运单
 * @Author: ganjia
 * @Date: 2019-10-11 10:09:33
 -->
<template>
  <div class="main-wrap waybill">
    <div class="waybill-top">
      <el-button type="primary" @click="exportOpen" :loading="exportLoading" icon="iconfont icondaochu" class="h40 exportOpen" plain>{{ $lang('导出') }}</el-button>
      <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
      <el-button type="primary" class="h40" @click="returnHandler" :disabled="!hasEdit">{{ $t('批量退回申请') }}</el-button>
      <el-button type="primary" class="h40" @click="handleSubmitReturnChange" :loading="isReturnLoading" :disabled="!isExchange">{{ $t('提交退换货') }}</el-button>
      <div class="waybill-topLeft" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="waybillNos">
            <base-input-tag
              style="width: 210px"
              v-model="searchParam.waybillNos"
              :placeholder="$lang('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="customerOrderIds">
            <base-input-tag
                style="width: 210px"
                v-model="searchParam.customerOrderIds"
                :placeholder="$lang('请输入客户订单号(最多可查100条)')"
                :clearBtnVisible="true"
                :addTagOnBlur="true"
                ref="customerOrderIds"
                class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="receiverMobilePhone">
            <el-input v-model="searchParam.receiverMobilePhone" :placeholder="$lang('请输入收件人联系电话')" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item props="userIds" class="account-userId">
            <el-select v-model="searchParam.userIds" multiple collapse-tags :placeholder="$lang('请选择下单账号')">
              <el-option
                v-for="item in accountOptions"
                :key="item.userId"
                :label="item.account"
                :value="item.userId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item props="expressTypeCodeList" class="account-userId">
            <el-select v-model="searchParam.expressTypeCodeList" multiple collapse-tags :placeholder="$lang('请选择产品类型')">
              <el-option
                v-for="item in productTypeOption"
                :key="item.id"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="waybill-bottom">
      <div class="waybill-nav">
        <div class="waybill-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ item.waybillStatusName }}<span class="waybill-nav-item-count">{{ item.count }}</span>
        </div>
      </div>

      <JmsTable
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-del="rowDel"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @current-change="currentChange">
        <!-- 运单号 -->
        <template slot="waybillNo" slot-scope="data">
          <el-tooltip placement="top">
            <div slot="content" @click="handleCopy(data)" style="cursor: pointer">{{ $lang('复制运单号') }}</div>
            <span @click="getExpressTracking(data.row.waybillNo)" class="getExpressTracking">{{ data.row.waybillNo }}</span>
          </el-tooltip>
        </template>
        <template slot="receiverMobilePhone" slot-scope="data">
          <div v-mask="{data: {...data.row,apiType:2},  key: 'receiverMobilePhone', type: 'waybillPlaintext' }"></div>
        </template>
        <template slot="receiverTelphone" slot-scope="data">
          <div v-mask="{data: {...data.row,apiType:2},  key: 'receiverTelphone', type: 'waybillPlaintext' }"></div>
        </template>

        <template slot="packageNumber" slot-scope="scope">
          <span style="color: #e60012;cursor: pointer;" @click="$refs.PackageNumberDialog.showDialog(scope.row.waybillNo)">{{ scope.row.packageNumber }}</span>
        </template>

        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text" :title="$lang('查看')">{{ $lang('查看') }}</el-button>
            <el-button v-if="permission(data.row) && showEdit(data.row.waybillStatusCode)"
                       @click="rowEdit(data.row, 'phone')"
                       type="text"
                       :title="$lang('修改电话')">
              {{ $lang('修改电话') }}
            </el-button>
            <el-button v-if="permission(data.row) && showEdit(data.row.waybillStatusCode) && !isReverse(data.row.expressTypeCode)"
                       @click="rowEdit(data.row, 'cod')"
                       type="text"
                       :title="$lang('修改COD')">
              {{ $lang('修改COD') }}
            </el-button>
            <el-button @click="showLog(data.row)" type="text" :title="$lang('修改详情')">{{ $lang('修改详情') }}</el-button>
          </div>
        </template>
      </JmsTable>
    </div>

    <el-dialog :title="$lang('提交退换货')" width="500px"
               :close-on-click-modal="false"
               :destroy-on-close="true"
               :modal-append-to-body="false"
               :visible.sync="isShowReturnsDialog">
      <div style="display: flex; flex-flow: row; align-items: center; justify-content: center; margin: 20px 0 30px;">
        <div style="margin-right: 10px;">{{ $lang('退换货类型') }}:</div>
        <el-select v-model="returnExchangeType" :placeholder="$lang('请选择')">
          <el-option :label="$lang('退货')" value="1"></el-option>
          <el-option :label="$lang('退换货')" value="2"></el-option>
        </el-select>
      </div>
      <div class="dialog-footer">
        <el-button @click="isShowReturnsDialog = false" class="h40">{{ $lang('取消') }}</el-button>
        <el-button type="primary" @click="handleSubmitReturnsExchangeApply" class="h40">{{ $lang('提交申请') }}</el-button>
      </div>
    </el-dialog>
    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet"
            :viewDialogVisible="viewDialogVisible"
            @closeDetails="closeDetails"
            @imgDialogChange="imgDialogChange"
            :bulletTitle="2"
            :rowData="rowData"/>
    <!-- 导出订单弹框组件 -->
    <export-componet ref="exportComponet"
                     :cityOptions="cityOptions"
                     :exportVisible="exportVisible"
                     :idsLength="selection.length"
                     :exportData="exportData"
                     @export-close="exportClose"
                     @export-fn="exportFn"/>
    <return-dialog ref="return-dialog" :waybillNos="selection" @submit-return="submitReturn"/>
    <apply-failure ref="apply-failure"/>
    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"/>
    <waybill-edit :rowData="rowData" ref="WaybillEdit" :editType="editType" :waybillLogStatus="waybillLogStatus" @saveHandler="saveHandler"/>
    <waybill-log ref="waybillLog"/>
    <PackageNumberDialog ref="PackageNumberDialog" :key="Math.random()"/>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import {
  asyExportWaybill,
  countByStatus, fetchOneSingleMultiple,
  getDetailById,
  modifyCod,
  queryCustomerOrderSource,
  rebackExpressBatchApplyCheck,
  updateReceiverMobilePhone,
  waybillDelete,
  waybillLogByCode,
  waybillOrder,
  getSearchAccounts,
  getProductTypeAll
} from '@/api/module/customer'
import { waybillPlaintext } from '@api/base/public'
import bullet from '@/components/base/BaseBullet.vue'
import exportComponet from '@/components/base/BaseExport.vue'
import { cityOptions, RESPONSE_SUCCESS } from '@/constants'
import { commonFun } from '@/utils/common'
import { mapGetters } from 'vuex'
import ExportDownloadDialog from '@/components/export-download-dialog/ExportDownloadDialog.vue'
import WaybillEdit from './components/WaybillEdit.vue'
import WaybillLog from './components/WaybillLog.vue'
import ReturnDialog from './components/ReturnDialog.vue'
import ApplyFailure from './components/ApplyFailure.vue'
import PackageNumberDialog from './components/PackageNumberDialog'

const waybillStatusObj = {
  201: '已揽件',
  202: '已发件',
  203: '运送中',
  204: '派件中',
  205: '已签收',
  206: '退件中',
  207: '已退件',
  208: '已拒收',
  300: '问题件',
}

export default {
  name: 'Waybill',
  mixins: [mixin],
  components: {
    JmsTable,
    bullet,
    exportComponet,
    ExportDownloadDialog,
    WaybillEdit,
    WaybillLog,
    ReturnDialog,
    ApplyFailure,
    PackageNumberDialog
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < dayjs().subtract(90, 'day').endOf('day').valueOf() || time.getTime() > dayjs().endOf('day').valueOf()
        }
      },
      COM_HTTP: {
        reqList: waybillOrder,
        // reqExcel: waybillExport,
        reqExcel: asyExportWaybill,
        reqDel: waybillDelete,
        reqDetail: getDetailById,
      },
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0],
        endTime: commonFun.GetTodayDate()[1],
        // endTime: '2021-12-31 23:59:59',
        // startTime: '2021-12-01 00:00:00',
        waybillNos: [], // 运单号
        customerOrderIds: [], // 客户订单号
        receiverMobilePhone: '', // 收件人手机号
        waybillStatusCode: 0, // 运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
        current: 1, // 当前页
        pageSize: 20, // 每页显示记录数
        orderSourceCode: '',
        userIds: [], // 账号userIds
        // orderSourceCodes: [],
        expressTypeCodeList: []
      },
      menuItems: [], // 导航栏
      activeIndex: '0',
      selection: [],
      exportVisible: false, // 导出弹框显示
      excelParams: {},
      exportStatus: 'all',
      exportType: 2, // 1：订单； 2：运单
      loading: false,
      exportLoading: false,
      exportData: {},
      cityOptions: [],
      delTitObj: {
        title: this.$lang('删除运单'),
        subTitle: this.$lang('你确定要删除已选中的运单吗？'),
        threeTitle: '',
      },
      orderSourceCodeList: [{ groupOrderSourceName: '全部', groupOrderSourceCode: '' }],
      tabActive: 0,
      dialogExportDownVisible: false, // 下载中心
      moduleType: 'my_waybill_qy', // 我的订单
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      receiverProvinceName: this.$lang('收件省份'),
      receiverCityName: this.$lang('收件城市'),
      receiverAreaName: this.$lang('收件区域'),
      editType: 'phone',
      waybillLogStatus: '',
      hasEdit: true,
      // 是否允许退换货提交按钮
      isExchange: false,
      // 退换货类型
      returnExchangeType: '',
      // 是否显示退换货弹窗
      isShowReturnsDialog: false,
      isReturnLoading: false,
      accountOptions: [], // 账号列表
      productTypeOption: [], // 产品类型
    }
  },
  async created() {
    const key = this.$route.params.typeNum
    // this.getOrderOrigin(key)
    this.getAccountList()
    this.getProductTypeAll()
    await this.countByStatus()
    if (key) {
      this.handleSelect(key)
    } else {
      this.searchFun()
    }
  },
  computed: {
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    },
    ...mapGetters([
      'user',
      'viewAllData',
      'operationAllData'
    ]),
    listOpt() {
      const that = this
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        fixHeight: 90,
        menuWidth: 250,
        selectable: (row, index) => {
          return that.permission(row)
        },
        //  搜索框和表格列及其字段
        column: [
          {
            label: this.$lang('运单编号'),
            prop: 'waybillNo',
            width: 200,
            slot: true,
          },
          {
            label: this.$lang('状态'), //  运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
            prop: 'waybillStatusCode',
            formatter({ waybillStatusCode }) {
              if (waybillStatusObj[waybillStatusCode]) {
                return that.$lang(waybillStatusObj[waybillStatusCode])
              }
              return '--'
            },
          },
          {
            label: this.$lang('下单渠道'),
            prop: 'orderSourceName',
            width: 200,
          },
          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderId',
            width: 150,
          },

          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderIds',
            show: false,
            sort: 5,
          },
          {
            label: this.$lang('收件人姓名'),
            prop: 'receiverName',
            width: 90,
          },
          // {
          //   label: this.$lang('收件方区号'),
          //   prop: 'receiverName',
          // },
          {
            label: this.$lang('收件人手机号'),
            prop: 'receiverMobilePhone',
            slot: true,
            width: 150,
          },
          {
            label: this.$lang('收件人备用手机号码'),
            prop: 'receiverTelphone',
            slot: true,
            width: 150,
          },
          {
            // label: this.$lang('收件省份'),
            label: that.receiverProvinceName,
            prop: 'receiverProvinceName',
            width: 90,
          },
          {
            // label: this.$lang('收件城市'),
            label: that.receiverCityName,
            prop: 'receiverCityName',
          },
          {
            // label: this.$lang('收件城市'),
            label: that.receiverAreaName,
            prop: 'receiverAreaName',
            show: that.countryId === 1
          },
          {
            label: this.$lang('收件街道'),
            prop: 'receiverStreet',
          },
          {
            label: this.$lang('收件详细地址'),
            prop: 'receiverDetailedAddress',
            width: 200,
          },
          {
            label: this.$lang('收件短地址'),
            prop: 'receiverShortAddress',
            show: that.countryId === 1
          },
          {
            label: this.$lang('物品类型'),
            prop: 'goodsTypeName',
          },

          {
            label: this.$lang('物品名称'),
            prop: 'goodsName',
          },
          {
            label: this.$lang('产品类型'),
            prop: 'expressTypeName',
          },
          {
            label: this.$lang('物品重量'),
            prop: 'packageTotalWeight',
          },
          {
            label: this.$lang('是否购买赔偿上限服务'),
            prop: 'insured',
            formatter({ insured }) {
              if (insured === 1) {
                return that.$lang('是')
              } else if (insured === 0) {
                return that.$lang('否')
              } else {
                return '--'
              }
            },
          },
          {
            label: this.$lang('货物价值'),
            prop: 'insuredAmount',
          },
          {
            label: this.$lang('赔偿上限服务费'),
            prop: 'insuredFee',
          },
          {
            label: this.$lang('件数'),
            prop: 'packageNumber',
            slot: true,
          },
          {
            label: this.$lang('结算方式'),
            prop: 'settlementName',
          },
          {
            label: this.$lang('支付方式'),
            prop: 'paidModeName',
          },
          {
            label: this.$lang('平台'),
            prop: 'platformName',
          },
          {
            label: this.$lang('客户账号'),
            prop: 'customerAccount',
          },
          {
            label: this.$lang('代收货款金额'),
            prop: 'codMoney',
            formatter({ codMoney, currencyName }) {
              if (codMoney) {
                return `${codMoney} ${currencyName}`
              } else {
                return '--'
              }
            },
          },
          {
            label: this.$lang('代收货款手续费'),
            prop: 'codFee',
            width: 110,
          },
          // {
          //   label: this.$lang('件数'),
          //   prop: 'packageNumber',
          // },
          // {
          //   label: this.$lang('赔偿上限服务费'),
          //   prop: 'insuredFee',
          // },
          {
            label: this.$lang('参考运费'),
            prop: 'totalFreight',
            show: this.user.freightStatus === 1,
          },
          {
            label: this.$lang('是否允许客户开箱验视'),
            prop: 'isUnpackEnabled',
            width: 200,
            formatter({ isUnpackEnabled }) {
              return isUnpackEnabled ? that.$lang('是') : that.$lang('否')
            },
          },
          {
            label: this.$lang('备注'),
            prop: 'remarks',
            width: 200,
          },
          {
            label: this.$lang('揽收时间'),
            prop: 'collectTime',
            width: 200,
          },
          {
            label: '派件天次',
            prop: 'numberOfDispatch',
            width: 200,
          },
          {
            label: '异常件原因',
            prop: 'exceptionReason',
            width: 200,
          },
          {
            label: '下单账户',
            prop: 'orderAccount',
            width: 200,
          },
        ],
      }
    },
  },
  watch: {
    'countryCode': {
      handler(val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.receiverProvinceName = that.$lang('收件酋长国')
          that.receiverCityName = that.$lang('收件区域')
        }
      },
      immediate: true,
    },
    selection: {
      handler(arr) {
        if (arr && arr.length) {
          this.hasEdit = arr.every(row => {
            return this.permission(row)
          })
        } else {
          this.hasEdit = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    isReverse(expressTypeCode) {
      return expressTypeCode === 'Reverse' || expressTypeCode === `Reverse${this.countryCode}` || expressTypeCode === 'ReverseKW'
    },
    // 获取产品类型
    async getProductTypeAll() {
      const { code, data, msg } = await getProductTypeAll({ countryId: this.countryId })
      if (code === RESPONSE_SUCCESS) {
        this.productTypeOption = data
      } else {
        this.$message.error(msg)
      }
    },
    // 获取账号列表
    async getAccountList() {
      const { code, data, msg } = await getSearchAccounts()
      console.log(code, data, msg, 'code, data, msg')
      if (code === RESPONSE_SUCCESS) {
        this.accountOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    permission(row) {
      const { isSelf } = row
      const { operationAllData } = this
      const isMasterAcc = this.user.parentId === 0
      return isMasterAcc || (!isMasterAcc && (operationAllData || isSelf))
    },
    async saveHandler(val, cb) {
      console.log(val, cb)
      const { waybillNo, receiverMobilePhone, receiverTelphone, beforeCodMoney, afterCodMoney, currencyName, currencyCode, codNeed, beforeCodNeed } = val
      let res = null
      try {
        res = this.editType === 'phone' ? await updateReceiverMobilePhone({
          receiverMobilePhone,
          receiverTelphone,
          waybillNo
        }) : await modifyCod({
          waybillNo,
          beforeCodMoney,
          afterCodMoney,
          currencyCode,
          currencyName,
          beforeCodNeed,
          codNeed: codNeed === true ? 1 : 0
        })
        if (res && res.succ) {
          this.$message.success(this.$lang('修改成功'))
          cb(true)
          this.searchFun(this.page.current)
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      } catch (error) {
        console.log(error)
      }
    },
    async rowEdit(row, type) {
      await this.viewFun(row)
      this.editType = type
      if (type === 'phone') {
        const res = await waybillPlaintext({ id: this.rowData.id, waybillNo: this.rowData.waybillNo, type: 2 })
        if (res.code === RESPONSE_SUCCESS) {
          this.rowData = { ...this.rowData, ...res.data }
        } else {
          console.error(res.msg)
        }
      }
      type === 'cod' && await this.getWaybillLogByCode(row.waybillNo)
      this.$refs.WaybillEdit.showDialog()
    },
    showLog(row) {
      console.log(row)
      this.$refs.waybillLog.showDialog(row.waybillNo)
    },
    // 运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件，208: 已拒收)
    showEdit (status) {
      return [201, 202, 203, 204, 206, 208].includes(status)
    },
    // 4种状态下可以修改cod,不管下单时是否选cod
    showEditCod (status) {
      return [201, 202, 203, 204].includes(status)
    },
    async getWaybillLogByCode (waybillNo) {
      try {
        const res = await waybillLogByCode({ waybillNo })
        if (res && res.succ) {
          this.waybillLogStatus = res.data ? res.data.status : ''
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description 复制
     */
    handleCopy(data) {
      const value = data.row.waybillNo
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success',
      })
      oInput.remove()
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.selection = []
    },
    // 获取下单渠道下拉数据，请求列表数据
    async getOrderOrigin(key) {
      try {
        const { code, data } = await queryCustomerOrderSource()

        if (code === RESPONSE_SUCCESS) {
          if (data.length) {
            this.orderSourceCodeList = this.orderSourceCodeList.concat(data)
          } else {
            this.orderSourceCodeList = []
          }
          await this.countByStatus()
          if (key) {
            this.handleSelect(key)
          } else {
            this.searchFun()
          }
        } else {
          this.orderSourceCodeList = []
        }
      } catch (error) {
        this.orderSourceCodeList = []
      }
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.selection = []
    },
    // 查看方法
    async viewFun(row) {
      if (this.isRowDetailUrl) {
        const { data, code, msg } = await this.COM_HTTP.reqDetail({ waybillNo: row.waybillNo }) // 根据运单号
        if (code === RESPONSE_SUCCESS) {
          console.log('查看调用成功')
          // 回显数据
          const newRow = this.handleData(data)
          this.rowData = Object.assign({}, { ...newRow })
        } else {
          this.$message.error(msg)
        }
        const res = await waybillPlaintext({ id: this.rowData.id, waybillNo: this.rowData.waybillNo, type: 2 })
        if (res.code === RESPONSE_SUCCESS) {
          this.rowData = { ...this.rowData, ...res.data }
        } else {
          console.error(res.msg)
        }
      } else {
        // 回显数据
        this.rowData = this.handleData(row)
      }
    },
    // 删除方法
    async deleteFun(item) {
      const res = await this.COM_HTTP.reqDel(item)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('删除成功'))
        this.afterDelSuccess()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 触发按钮查询
    searchChange(params) {
      const { startdate, enddate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime = new Date(startdate).getTime()
      const endTime = new Date(enddate).getTime()
      if (endTime - startTime > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      this.searchParam.waybillStatusCode = this.menuItems[this.activeIndex].waybillStatusCode

      const { waybillNos, customerOrderIds } = this.searchParam
      // 处理运单编号
      if (waybillNos && waybillNos.length !== 0) {
        if (waybillNos.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }
      // 处理客户订单编号
      if (customerOrderIds && customerOrderIds.length !== 0) {
        if (customerOrderIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条客户订单号'))
        }
      }
      this.searchFun(1)
      this.countByStatus()
    },
    // 搜索-获取参数
    getParams() {
      const { startTime, endTime, waybillNos, receiverMobilePhone, waybillStatusCode, customerOrderIds, userIds, expressTypeCodeList } = this.searchParam
      return {
        pageSize: this.page.size,
        startTime: waybillNos.length || customerOrderIds.length ? '' : startTime,
        endTime: waybillNos.length || customerOrderIds.length ? '' : endTime,
        waybillNos, // 运单号
        customerOrderIds, // 客户订单号
        receiverMobilePhone, // 收件人手机号
        waybillStatusCode: waybillStatusCode, // 运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
        // orderSourceCodes: this.getOrderOriginCode(orderSourceCode), // 下单渠道
        userIds,
        expressTypeCodeList
      }
    },
    // 导出-获取参数
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      // 获取选中行的数量
      const len = (this.selection && this.selection.length) || 0
      // 选中行ids处理（未选中不穿此参数）
      if (len) ids = this.selection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { ids, sort, columnNames, orderStatusCode: this.exportStatus }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      return params
    },
    // 快捷菜单搜索
    handleSelect(key) {
      const menuItems = this.menuItems
      const { waybillStatusCode } = menuItems[key]
      this.searchParam.waybillStatusCode = waybillStatusCode
      this.exportStatus = waybillStatusCode
      this.activeIndex = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.searchFun()
      this.countByStatus()
    },
    // 更新导出参数配置
    updateOutExcel(key = 0) {
      // cityOptions
      const collectTime = {
        key: 'collectTime',
        name: this.$lang('揽收时间'),
      }
      const dispatchTime = {
        key: 'dispatchTime',
        name: this.$lang('派件时间'),
      }
      const signTime = {
        key: 'signTime',
        name: this.$lang('签收时间'),
      }
      // refundTime 退件时间？
      const refundTime = {
        key: 'refundTime',
        name: this.$lang('退件签收时间'),
      }
      // inputTime 录入时间？
      const inputTime = {
        key: 'inputTime',
        name: this.$lang('运送时间'),
      }
      // this.cityOptions.push(collectTime, dispatchTime, signTime, refundTime)
      switch (key) {
        case 0: // 全部运单
          this.cityOptions.push(collectTime, dispatchTime, signTime, refundTime)
          break
        case 1: // 已揽件
          this.cityOptions.push(collectTime)
          break
        case 2: // 运送中
          this.cityOptions.push(inputTime)
          break
        case 3: // 派送中
          this.cityOptions.push(dispatchTime)
          break
        case 4: // 已签收
          this.cityOptions.push(signTime)
          break
        case 5: // 退件中
          break
        case 6: // 已退件
          this.cityOptions.push(inputTime)
          break
        default:
          // 默认
          break
      }
    },
    // 删除
    delFn() {
      this.$refs.delOrder.dialogTableVisible = true
    },
    // 打开导出弹框
    async exportOpen() {
      if (this.selection.length <= 0) {
        this.exportLoading = true
        await this.countByStatus()
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.menuItems[this.activeIndex].count || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.cityOptions = [...cityOptions]
      if (this.countryId === 1) {
        const receiverAreaName = {
          key: 'receiverAreaName',
          name: '收件区域'
        }
        const senderAreaName = {
          key: 'senderAreaName',
          name: '寄件区域'
        }
        this.cityOptions.push(receiverAreaName, senderAreaName)
      }
      /**
       * @description 如果设置了 不显示参考运费 删除参考运费
       */
      if (this.user.freightStatus === 0) {
        const chooseIndex = this.cityOptions.findIndex(item => item.name === '参考运费')
        // 删除参考运费选项
        this.cityOptions.splice(chooseIndex, 1)
      }
      this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      const exportData = {
        exportStatus: this.exportStatus,
        exportType: this.exportType, // 1：订单； 2：运单
      }
      this.exportData = exportData
    },
    // 关闭导出弹框
    exportClose(val) {
      this.exportVisible = val
    },
    // 导出数据
    async exportFn(status, data, dataParams) {
      this.exportVisible = status
      this.columnList = data
      this.excelParams = dataParams
      // 调用导出方法
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportWaybill()
    },
    async asyExportWaybill() {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请前往下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 选择日期
    selectDate() {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.startTime = start
        this.searchParam.endTime = end
      }
    },
    // 获取运单状态列表
    async countByStatus() {
      const { startTime, endTime, waybillNos, receiverMobilePhone, customerOrderIds, userIds, expressTypeCodeList } = this.searchParam
      const params = {
        startTime: waybillNos.length || customerOrderIds.length ? '' : startTime,
        endTime: waybillNos.length || customerOrderIds.length ? '' : endTime,
        waybillNos, // 运单号
        customerOrderIds, // 客户订单号
        receiverMobilePhone, // 收件人手机号
        userIds,
        expressTypeCodeList
      }
      console.log('params', params)
      const { code, data } = await countByStatus(params)
      if (code === 1) {
        this.menuItems = data
      }
    },
    getOrderOriginCode(orderSourceCode) {
      let codes = []
      if (!orderSourceCode) {
        codes = this.orderSourceCodeList.map(item => item.groupOrderSourceCode)
      } else {
        codes = [orderSourceCode]
      }
      return codes
    },
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
    },
    imgDialogChange(val) {
      if (val) this.viewDialogVisible = false
      if (!val) this.viewDialogVisible = true
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        ids: [],
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0],
        endTime: commonFun.GetTodayDate()[1],
        orderSourceCode: '',
        // orderSourceCodes: [],
      }
      this.$refs.BaseInputTag1.clearFn()
      this.$refs.customerOrderIds.clearFn()
    },
    // 表格复选框选择回调
    selectionChange(val) {
      this.selection = val
      this.isExchange = val.length === 1 && (this.tabActive === 4 || waybillStatusObj[val[0].waybillStatusCode] === '已签收')
    },
    // 删除后的回调
    afterDelSuccess() {
      this.searchFun(1)
      setTimeout(this.countByStatus, 500)
    },
    changeTab(index) {
      this.tabActive = index
      this.handleSelect(index)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    submitReturn(data) {
      setTimeout(_ => {
        this.$refs['apply-failure'].showDialog(data)
      }, 100)
    },
    async returnHandler() {
      console.log(this.selection)
      const waybillNos = this.selection.map(({ waybillNo }) => waybillNo).join()
      try {
        const res = await rebackExpressBatchApplyCheck({ waybillNos })
        if (res && res.succ) {
          const data = res.data
          if (data && data.length) {
            this.$refs['return-dialog'].showDialog(data)
          } else {
            this.$message.error(this.$t('所选运单暂不支持退回申请'))
          }
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 提交退换货申请
     * @returns {ElMessageComponent}
     */
    handleSubmitReturnsExchangeApply() {
      if (!this.returnExchangeType) {
        return this.$message.info(this.$lang('请选择退换货类型'))
      }
      if (this.selection.length === 1) {
        this.isShowReturnsDialog = false
        this.$router.push({
          path: `/submitReturns/${this.selection[0].waybillNo}/${this.returnExchangeType}`,
        })
        this.$refs['table'].$refs['table'].clearSelection()
      } else {
        this.$message.error(this.$lang('退换货失败'))
      }
    },
    /**
     * 提交退换货一票多件限制
     * @returns {Promise<void>}
     */
    async handleSubmitReturnChange() {
      this.isReturnLoading = true
      const { code, msg } = await fetchOneSingleMultiple({
        waybillNo: this.selection[0].waybillNo
      })
      this.isReturnLoading = false
      if (code === RESPONSE_SUCCESS) {
        this.isShowReturnsDialog = true
      } else {
        this.$message.error(msg)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
// @import '@assets/iconfont/iconfont.css
.el-form-item {
  margin-bottom: 0;
}

.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}

.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}

.waybill {
  .waybill-top {
    //   padding :24px;
    padding: 16px 24px;

    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }

    .waybill-topLeft {
      margin-top: 10px;
    }
  }

  .waybill-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }

  .waybill-nav {
    //   margin: 9px 0;
    .waybill-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 16px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      //   width: 124px;
      &:first-of-type {
        margin-left: 0px;
      }

      i {
        margin-right: 8px;
        color: #666;
      }

      &.active {
        background: #fff;
        color: #e60012;

        i {
          color: #e60012;
        }
      }
    }

    .waybill-nav-item-count {
      display: inline-block;
      width: 28px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>

<style lang="scss">
.waybill .waybill-top .el-input__inner {
  margin-bottom: 10px;
}
.account-userId {
  .el-select>.el-input {
    width: 200px !important;
  }
  .el-input--small .el-input__icon {
    line-height: 50px !important;
  }
}
</style>
